import { useContext, useState } from 'react';
import Carging from '../../components/Carging';
import { ConfigContext } from '../../context/configContext';

const About = () => {

    const { about, setAbout, updateConfig } = useContext(ConfigContext);
    const [isSaving, setisSaving] = useState(false);

    if (about === null) {
        return <Carging />
    }

    const handdleSubmit = (e) => {
        e.preventDefault();
        setisSaving(true);
        updateConfig({ ...about })
            .then(() => {
                setisSaving(false);
            })

    }


    return (
        <div className="h-100 p-5">
            <div className="d-flex justify-content-between align-items-center">
                <div className="md-0">
                    <strong className="fs-4">Text</strong> <br />
                    <small className="text-gray">This is the message that the principla pagel shows</small>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                <form className="col-12" onSubmit={(e) => handdleSubmit(e)}>
                    <div className="form-floating my-3">
                        <input
                            id="title"
                            type="text"
                            className='form-control'
                            placeholder='Text'
                            value={about.title}
                            onChange={(e) => setAbout({ ...about, title: e.target.value })}
                        />
                        <label htmlFor='title'>Title</label>

                    </div>
                    <div className="form-floating mb-3">
                        <textarea
                            value={about.text}
                            onChange={(e) => setAbout({ ...about, text: e.target.value })}
                            className="form-control"
                            placeholder="Leave a comment here"
                            id="saludo" />
                        <label htmlFor="saludo">Comments</label>
                    </div>
                    <div className="form-floating mb-3">
                        <input
                            value={about.facebook}
                            id="facebook"
                            placeholder='Faceebook url '
                            onChange={(e) => setAbout({ ...about, facebook: e.target.value })}
                            type="text"
                            className='form-control'
                        />
                        <label htmlFor='facebook'>Facebook</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={about.twitter}
                            id="twitter"
                            placeholder='Twitter url '
                            onChange={(e) => setAbout({ ...about, twitter: e.target.value })}
                            type="text"
                            className='form-control'
                        />
                        <label htmlFor='twitter'>Twiiter</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={about.instagram}
                            id="instagram"
                            placeholder='Instagram url'
                            onChange={(e) => setAbout({ ...about, instagram: e.target.value })}
                            type="text"
                            className='form-control'
                        />
                        <label htmlFor='Instagram'>Instagram</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={about.linkedin}
                            id="linkedin"
                            placeholder='Instagram url'
                            onChange={(e) => setAbout({ ...about, linkedin: e.target.value })}
                            type="text"
                            className='form-control'
                        />
                        <label htmlFor='linkedin'>Linkedin</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={about.github}
                            id="github"
                            placeholder='Instagram url'
                            onChange={(e) => setAbout({ ...about, github: e.target.value })}
                            type="text"
                            className='form-control'
                        />
                        <label htmlFor='github'>Github</label>
                    </div>

                

                    <div className="text-end">
                        <button type="submit" className="btn btn-primary">
                            Save
                            {isSaving && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                        </button>
                    </div>
                </form>


            </div>
        </div>
    )

}

export default About